import { request } from './request';

export const getAllNurses = () => {
  return request('nurses');
};
